import React from 'react'
import { Modal } from 'antd'
import './index.scss'

export default function AutomatedTrafficFineNotificationErrorModal({
  open = false,
  onClose = () => {},
  title = 'Thất bại',
  content = 'Đã có lỗi xảy ra. Vui lòng thử lại sau.'
}) {
  return (
    <Modal
      open={open}
      closable={false}
      footer={[
        <button key="ok" type="button" onClick={onClose} className="error-modal-button">
          Đã hiểu
        </button>
      ]}
      width="90%"
      centered
      style={{ height: 'auto' }}
      bodyStyle={{ borderRadius: '14px', paddingTop: '8px' }}
      footerStyle={{ padding: 0 }}
      className="automated-traffic-fine-notification-error-modal">
      <div className="error-modal-content">
        <div className="error-modal-title">{title}</div>
        <div className="error-modal-message">{content}</div>
      </div>
    </Modal>
  )
}
